import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Stack,
  Paper,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Chip
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { ENDPOINT, IMAGE_BASE_URL } from "../../../endpoints/endpoints";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const TableUpdate = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [formData, setFormData] = useState({
    league_id: "",
    team_id: "",
    pl:"",
    w:"",
    d:"",
    l:"",
    plusandminus:"",
    gd:"",
    pts:"",
    position:""
  });

  const token = localStorage.getItem("accessToken");

  const [loading, setLoading] = useState(false);

  const [leagues, setLeagues] = useState([]);
  const [leagueSearch, setLeagueSearch] = useState("");
  const [filteredLeagues,setfilteredleague] = useState([]);

  const [teams, setTeams] = useState([]);
  const [teamSearch, setTeamSearch] = useState("");
  const [filteredTeams,setfilteredteam] = useState([]);

  const [form,setForm] = useState([])
  const [newValue, setNewValue] = useState("w");
  const [editingIndex, setEditingIndex] = useState(null);

  const getFormData = (value) => {
    switch (value) {
      case "w":
        return { value: "w", label: "W", color: "#00C853" };
      case "d":
        return { value: "d", label: "D", color: "#9E9E9E" };
      case "l":
        return { value: "l", label: "L", color: "#D32F2F" };
      case "-":
      default:
        return { value: "-", label: "-", color: "#BDBDBD" };
    }
  };

  const handleAdd = () => {
    setForm((prev) => [...prev, getFormData(newValue)]);
  };

  const handleUpdate = (index, value) => {
    const updated = [...form];
    updated[index] = getFormData(value);
    setForm(updated);
    setEditingIndex(null);
  };

  const handleDelete = (index) => {
    setForm(form.filter((_, i) => i !== index));
  };

  useEffect(() => {
    if (!token) {
      toast.warning("Please log in to continue");
      navigate("/login");
    } else {
      fetchAllLeagues();
      fetchAllTeam();
      fetchDetail();
    }
  }, [navigate]);

   const fetchDetail = async () => {
        setLoading(true);
        try {
          const token = localStorage.getItem("accessToken");
  
          const res = await axios.get(ENDPOINT.TABLE_DETAIL(id), {
            headers: { Authorization: `Bearer ${token}` },
          });
          const data = res.data.data
          
          setFormData({...data,
            league_id: data?.league?.id ?? "",
            team_id: data?.team?.id ?? "",})
          setForm(data.form)
          console.log(data)
        } catch (err) {
          toast.error("Failed to fetch table detail");
        } finally {
          setLoading(false);
        }
      };

  const fetchAllLeagues = async () => {
    try {
      let url = ENDPOINT.LEAGUECATEGORY_LIST;
      let allResults = [];

      while (url) {
        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });

        allResults = [...allResults, ...res.data.results];
        url = res.data.next; // load next pages
      }

      setLeagues(allResults);
      setfilteredleague(allResults)
    } catch (error) {
      console.error("Error loading league list:", error);
      toast.error("Failed to load leagues");
    }
  };

  const fetchAllTeam = async () => {
    try {
      let url = ENDPOINT.TEAM_LIST;
      let allResults = [];

      while (url) {
        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });

        allResults = [...allResults, ...res.data.results];
        url = res.data.next; // load next pages
      }

      setTeams(allResults);
      setfilteredteam(allResults)
    } catch (error) {
      console.error("Error loading team list:", error);
      toast.error("Failed to load teams");
    }
  };

  useEffect(()=>{
  let filteredLeague = leagues.filter((l) =>
    l.name.toLowerCase().includes(leagueSearch.toLowerCase())
  );
  setfilteredleague(filteredLeague)
  },[leagueSearch])

  useEffect(()=>{
  let filteredTeam = teams.filter((t) =>
    t.name.toLowerCase().includes(teamSearch.toLowerCase())
  );
  setfilteredteam(filteredTeam)
  },[teamSearch])
  

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  // ============================================================
  // 🚀 Submit Form
  // ============================================================
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (!token) {
        toast.error("You must log in first!");
        navigate("/login");
        return;
      }

      const data = new FormData();
      Object.keys(formData).forEach((key) => {
          data.append(key, formData[key]);
        });

      data.append("form",JSON.stringify(form))

      console.log(data)

      const response = await axios.put(ENDPOINT.TABLE_UPDATE(id), data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      const msg = response.data.message || "Table updated successfully";

      toast.success(msg);
      setTimeout(() => navigate("/table/list"), 1200);
    } catch (err) {
      console.error("Error updating Table:", err);
      toast.error(
        err.response?.data?.message ||
          err.response?.data?.detail ||
          "Something went wrong."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 5, mb: 5 }}>
      <ToastContainer position="top-right" autoClose={3000} />

      <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
        <Typography variant="h5" fontWeight={600} mb={3}>
          🖼 Update Table
        </Typography>

        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <Stack spacing={2}>

            <TextField
            label="Position"
            name="position"
            value={formData.position}
            onChange={handleChange}
            fullWidth 
            required
          />

             <FormControl fullWidth>
              <InputLabel id="league-label">League</InputLabel>

              <Select
                labelId="league-label"
                label="League"
                name="league_id"
                value={formData.league_id}
                onChange={handleChange}
                required
                MenuProps={{ PaperProps: { style: { maxHeight: 350 } } }}
              >
                {/* Search Box */}
                <MenuItem disableRipple>
                  <TextField
                    fullWidth
                    placeholder="Search league..."
                    size="small"
                    value={leagueSearch}
                    onChange={(e) => setLeagueSearch(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    onKeyDown={(e) => e.stopPropagation()} 
                  />
                </MenuItem>

                <MenuItem disabled>
                  <Typography variant="caption" color="text.secondary">
                    {filteredLeagues.length} results
                  </Typography>
                </MenuItem>

                {filteredLeagues.map((l) => (
                  <MenuItem key={l.id} value={l.id}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Box
                        component="img"
                        src={`${IMAGE_BASE_URL}${l.image}`}
                        alt={l.name}
                        sx={{
                          width: 28,
                          height: 28,
                          borderRadius: "50%",
                          mr: 1.5,
                        }}
                      />
                      {l.name}
                    </Box>
                  </MenuItem>
                ))}

                {filteredLeagues.length === 0 && (
                  <MenuItem disabled>No results found</MenuItem>
                )}
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel id="team-label">Team</InputLabel>

              <Select
                labelId="team-label"
                label="League"
                name="team_id"
                value={formData.team_id}
                onChange={handleChange}
                required
                MenuProps={{ PaperProps: { style: { maxHeight: 350 } } }}
              >
                {/* Search Box */}
                <MenuItem disableRipple>
                  <TextField
                    fullWidth
                    placeholder="Search team..."
                    size="small"
                    value={teamSearch}
                    onChange={(e) => setTeamSearch(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    onKeyDown={(e) => e.stopPropagation()} 
                  />
                </MenuItem>

                <MenuItem disabled>
                  <Typography variant="caption" color="text.secondary">
                    {filteredTeams.length} results
                  </Typography>
                </MenuItem>

                {filteredTeams.map((t) => (
                  <MenuItem key={t.id} value={t.id}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Box
                        component="img"
                        src={`${IMAGE_BASE_URL}${t.image}`}
                        alt={t.name}
                        sx={{
                          width: 28,
                          height: 28,
                          borderRadius: "50%",
                          mr: 1.5,
                        }}
                      />
                      {t.name}
                    </Box>
                  </MenuItem>
                ))}

                {filteredTeams.length === 0 && (
                  <MenuItem disabled>No results found</MenuItem>
                )}
              </Select>
            </FormControl>

          <TextField
            label="Pl"
            name="pl"
            value={formData.pl}
            onChange={handleChange}
            fullWidth 
            required
          />

          <TextField
            label="W"
            name="w"
            value={formData.w}
            onChange={handleChange}
            fullWidth 
            required
          />

          <TextField
            label="D"
            name="d"
            value={formData.d}
            onChange={handleChange}
            fullWidth 
            required
          />

          <TextField
            label="L"
            name="l"
            value={formData.l}
            onChange={handleChange}
            fullWidth 
            required
          />

          <TextField
            label="+/-"
            name="plusandminus"
            value={formData.plusandminus}
            onChange={handleChange}
            fullWidth 
            required
          />

          <TextField
            label="GD"
            name="gd"
            value={formData.gd}
            onChange={handleChange}
            fullWidth 
            required
          />

          <TextField
            label="Pts"
            name="pts"
            value={formData.pts}
            onChange={handleChange}
            fullWidth 
            required
          />

           <Box>
      <Typography variant="h6" gutterBottom>
        Form
      </Typography>

      <TableContainer component={Paper} sx={{ width: "33%" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Form</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {form.map((item, index) => (
              <TableRow key={index}>
                <TableCell>
                  {editingIndex === index ? (
                    <Select
                      size="small"
                      value={item.value}
                      onChange={(e) =>
                        handleUpdate(index, e.target.value)
                      }
                    >
                      <MenuItem value="w">W</MenuItem>
                      <MenuItem value="d">D</MenuItem>
                      <MenuItem value="l">L</MenuItem>
                      <MenuItem value="-">-</MenuItem>
                    </Select>
                  ) : (
                    <Chip
                      label={item.label}
                      color={item.color}
                      size="small"
                       sx={{
                        backgroundColor: item.color,
                        color: "#ffffff",
                        fontWeight: 600
                      }}
                    />
                  )}
                </TableCell>

                <TableCell>
                  <IconButton
                    size="small"
                    onClick={() => setEditingIndex(index)}
                  >
                    <EditIcon />
                  </IconButton>

                  <IconButton
                    size="small"
                    color="error"
                    onClick={() => handleDelete(index)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Add new row */}
      <Box mt={2} display="flex" alignItems="center">
        <Select
          size="small"
          value={newValue}
          onChange={(e) => setNewValue(e.target.value)}
        >
          <MenuItem value="w">W</MenuItem>
          <MenuItem value="d">D</MenuItem>
          <MenuItem value="l">L</MenuItem>
          <MenuItem value="-">-</MenuItem>
        </Select>

        <Button
          variant="contained"
          sx={{ ml: 2 }}
          onClick={handleAdd}
        >
          Add
        </Button>
      </Box>
    </Box>

            {/* Submit Button */}
            <Box textAlign="right" mt={2}>
              <Button
                type="submit"
                variant="contained"
                color="success"
                disabled={loading}
                sx={{ px: 4 }}
              >
                {loading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Update Table"
                )}
              </Button>
            </Box>
          </Stack>
        </form>
      </Paper>
    </Container>
  );
};

export default TableUpdate;
